/** Ligne de saisie d'un compte bancaire dans un formulaire de création d'acteur. */
export interface BankAccountFormRow {
  iban: string;
  label: string;
  bic: string;
  isDefault: boolean;
}

export const EMPTY_BANK_ACCOUNT_ROW: BankAccountFormRow = {
  iban: '',
  label: '',
  bic: '',
  isDefault: false,
};
